export const QUICK_MESSAGE_REACTIONS = Object.freeze([
  { reaction: '\u2764\uFE0F', label: 'heart' },
  { reaction: '\u{1F602}', label: 'laughing face' },
  { reaction: '\u{1F62E}', label: 'surprised face' },
  { reaction: '\u{1F622}', label: 'crying face' },
  { reaction: '\u{1F621}', label: 'angry face' },
  { reaction: '\u{1F44D}', label: 'thumbs up' },
]);

export const normalizeMessageReaction = (value) =>
  typeof value === 'string' ? value.trim().normalize('NFC') : '';

export const getReactionPlayerKey = (reaction) =>
  String(reaction?.player || reaction?.playerId || '').trim();

export const getMessageReactionGroups = (message, currentPlayerId) => {
  const groups = new Map();
  const mineKey = currentPlayerId ? String(currentPlayerId) : '';

  (Array.isArray(message?.reactions) ? message.reactions : []).forEach(
    (entry) => {
      const reaction = normalizeMessageReaction(entry?.reaction);
      const playerKey = getReactionPlayerKey(entry);
      if (!reaction || !playerKey) return;

      if (!groups.has(reaction)) {
        groups.set(reaction, {
          reaction,
          count: 0,
          isMine: false,
        });
      }

      const group = groups.get(reaction);
      group.count += 1;
      if (mineKey && playerKey === mineKey) group.isMine = true;
    },
  );

  return Array.from(groups.values());
};

export const mergeMessageById = (messages, updatedMessage) => {
  const key = updatedMessage?._id || updatedMessage?.messageId;
  if (!key) return messages;

  let matched = false;
  const nextMessages = messages.map((message) => {
    const messageKey = message?._id || message?.messageId;
    if (String(messageKey) !== String(key)) return message;
    matched = true;
    return { ...message, ...updatedMessage };
  });

  return matched ? nextMessages : messages;
};
